<template>
  <div class="wrapper mainContent">
    <Header/>
    <div class="search-box center-wrapper">
      <div class="left-box">
        <el-carousel arrow="never">
          <el-carousel-item v-for="(item,index) in carousel" :key="item.id">
            <div class="carousel-box">
              <img :src="item.img_url"  style="object-fit: fill;height:100%;width:100%;">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="right-box">
        <div class="topLoginBox">
          <img class="topLoginImg" src="../assets/img/zbt_logo.png" alt="">
          <!--                      <img class="topLoginImgRight" @click="()=>{loginModel = !loginModel}" v-if="loginModel" src="../assets/img/login_user_change1.png" alt="">-->
          <!--                      <img class="topLoginImgRight" @click="()=>{loginModel = !loginModel}" v-else src="../assets/img/login_scan_change1.png" alt="">-->
          <img class="topLoginImgRight" src="../assets/img/login_scan_change1.png" alt="">
        </div>
        <div v-if="loginModel">
          <el-form
              ref="form"
              :model="form"
              :rules="rules"
          >
            <el-form-item label="">
              <div class="inputBox">
                <span><img src="../assets/img/login_user_icon.png" alt=""></span>
                <input type="text" placeholder="用户名/已验证邮箱/已验证手机" v-model="form.userName">
              </div>
            </el-form-item>
            <el-form-item label="">
              <div class="inputBox">
                <span><i class="iconfont usericon"><img src="../assets/img/login_password_icon.png" alt=""></i></span>
                <input type="password" placeholder="密码" v-model="form.passWord">
              </div>
            </el-form-item>

            <el-button type="submit" class="loginBtn" @click="onSubmit('form')">登录</el-button>
            <div class="sign-reg-ok user-login-part" style="width: 50%;">
              <a target="_blank" href="/Public/register.shtml" style="float:left;color:#666;">立即注册</a>
              <a target="_blank" href="/Public/findPwd.shtml" style="float: right;color: #4f93fe;">忘记密码？</a>
            </div>
          </el-form>
        </div>
        <div v-else>
          <div class="ewmLoginContent">
            <img class="ewmLoginContentWeiyi" src="../assets/img/code.png" alt="">
            <img class="ewmLoginContentImgtips" src="../assets/img/login_scan_tips.png" alt="">
          </div>
          <img class="ewmLoginBttom" src="../assets/img/login_tips.png" alt="">
          <div class="sign-reg-ok" style="width: 50%;margin: auto;margin-top: 30px;">
            <a @click="()=>{loginModel = !loginModel}" style="float: left;color: #4f93fe;">账号登录</a>
            <a style="float:right;color:#666;">立即注册</a>
          </div>
        </div>
      </div>
    </div>

    <div class="msg-box center-wrapper">
      <JewelsMeaasge :dataList = "newsList" :key="num"/>
    </div>
    <div class="all-trade center-wrapper">
      <p class="allNews">全部资讯</p>
      <hr>
      <div class="detail-item" v-for="(item,index) in newsList" :key="index" @click="newsDetail(item)">
        <div class="detail-img">
          <img :src="item.img_url" alt="">
        </div>
        <div class="word-box">
          <h1 style="cursor:pointer">{{item.title}}</h1>
          <p v-html="item.content"></p>
          <div class="sub-box">
            <div>
              <img src="../assets/img/seeIcon.png" alt="">
              <span>{{item.views}}阅读</span>
            </div>
            <div>
              {{item.create_date}}
            </div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            layout="prev, pager, next, jumper"
            prev-text="上一页"
            next-text="下一页"
            :total="total"
            ref="pageGroup"
        >
        </el-pagination>
      </div>
    </div>
    <aboutUsFooterVue/>
    <Footer/>
  </div>
</template>

<script>
import JewelsMeaasge from "../components/JewelsMeaasge";
import Header from "../components/Header";
import Footer from "../components/Footer";
import aboutUsFooterVue from "../components/aboutUsFooter.vue";
import {fetchNewspmList, fetchExpertBanner, newsList} from '@/api/api';
import axios from 'axios'
import qs from 'qs'
export default {
  name:'HomeViewVue',
  components: {
    Header,
    JewelsMeaasge,
    Footer,
    aboutUsFooterVue
  },
  props: {},
  data() {
    return {
      errors: [],
      // true 为账号密码 false 为二维码
      loginModel: true,
        carousel: [
            {img_url: require('../assets/img/b5.jpg')}, 
            {img_url: require('../assets/img/gsp-support.jpg')},
            {img_url: require('../assets/img/b2.jpg')},
            {img_url: require('../assets/img/b4.jpg')},
            {img_url: require('../assets/img/b1.jpg')}
        ],
      form:{
        userName:'',
        passWord:'',
      },
      rules:{},
      newsList: [],
      num:0,
      currentPage:1,
      size: 12,
      total:0,

    };
  },
  watch: {},
  computed: {},
  created() {
    this.readList();
  },
  mounted() {
    document.onkeydown = e => {
      console.log(e)
      if ( e.keyCode === 13 ) {
        this.onSubmit()
      }
    }
  },
  methods:{
    onSubmit () {
      if ( !this.form.userName ) {
        this.$message.error('账号不能为空')
        return false
      } else if ( !this.form.passWord ) {
        this.$message.error('密码不能为空')
        return false
      }

      fetch('/Public/login.shtml', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: qs.stringify(this.form),
        redirect: "manual"
      }).then(res => {
        if ( res.status == 200 ) {
          this.$message.error('账号或密码错误');
        }
        if (res.type === "opaqueredirect") {
          // redirect to login page
          window.location.href = res.url;
        }
      }).catch(e => {
        console.log(e)
        this.$message.warning('系统繁忙请稍后再试');
      })

      // axios({
      //   url: '/api/Public/login.shtml',
      //   method: 'POST',
      //   data: qs.stringify(this.form),
      // }).then(res => {
      //   if ( res.status == 200 ) {
      //     this.$message.error('账号或密码错误');
      //   }
      //   if (res.type === "opaqueredirect") {
      //     // redirect to login page
      //     window.location.href = res.url;
      //   }
      //   console.log(res)
      // }).catch(e => {
      //   console.log(e)
      // })
    },
    readList () {
      newsList({per_page: this.size, page: this.currentPage}).then(r => {
        if(r.data?.data.length) {
          this.newsList = r.data.data.map(item => {
            item.content = item.content.replace(/&lt;/ig, '<').replace(/&gt;/ig, '>').replace(/&quot;/ig, '"').replace(/&amp;nbsp;/ig, ' ').replace(/<[^>]+>/g,"")
            return item
          })
          this.total = Number(r.data.count);
        }else {
          this.newsList = [];
        }
        this.num = 1;
      })
    },
    newsDetail(item){
      window.open(`https://www.zbtesting.com/#/articleContent?articleId=${item.id}`)
    },
    handleSizeChange (e){
      this.size = e
      this.readList()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.readList()
    },
  }
};
</script>
<style lang="scss" scoped>
.mainContent {
  background: rgba(240, 240, 240, 1);
  a {
    text-decoration: none;
  }
}
.wrapper{
  .search-box {
    background-color: #f9f9f9;
    margin-top: 50px;
    display: flex;
    height: 500px;
    // box-shadow: 0px 4px 50px rgba(122, 145, 158, 0.25);
    box-shadow: 0 0 10px rgb(0 0 0 / 50%);
    border-radius: 20px;
    .left-box {
      width: 66%;
      height: 100%;
      .carousel-box {
        cursor: pointer;
        height: 100%;
      }
      .el-carousel{
        height: 100%;
        border-radius: 14px 0 0 14px;
      }
      & ::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
        width: 10px;
        height: 10px;
        background: transparent;
        border: 1px solid #ffffff;
        border-radius: 50%;
        opacity: 0.5;
      }
      & ::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button{
        width: 10px;
        height: 10px;
        background: #ffffff;
        border-radius: 50%;
        opacity: 1;
      }
      & ::v-deep .el-carousel__container {
        height: 100%!important;
      }
      & ::v-deep .el-carousel__indicators {
        z-index: 100;
      }
      & ::v-deep .el-carousel__indicators--horizontal {
        // top: 64%;
      }
    }
    .right-box {
      width: 33%;
      padding: 40px;
      border-radius: 10px;
      & ::v-deep .el-form-item{
        margin-bottom: 0px;
      }
      .topLoginBox {
        margin-bottom: 30px;
        position: relative;
        .topLoginImg {
          width: 70%;
          margin: 0 auto;
          display: block;
        }
        .topLoginImgRight {
          cursor: pointer;
          position: absolute;
          right: -25px;
          top: -25px;
        }
      }
      .inputBox {
        width: 100%;
        height: 46px;
        margin-bottom: 14px;
        border: 1px solid #f2f2f2;
        background-color: #fff;
        border-radius: 6px;
        span {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 15%;
          height: 100%;
          float: left;
          border-radius: 6px 0 0 6px;
          box-sizing: border-box;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            width: 2px;
            height: 20px;
            background: #f5f5f5;
            right: 0px;
            top: 12px;
          }
        }
        input {
          float: right;
          width: 85%;
          height: 100%;
          margin-left: 0;
          border: 0;
          padding-left: 10px;
          box-sizing: border-box;
          outline: none;
        }
      }
      .sign-reg-ok {
        width: 100%;
        margin: 78px auto;
        height: 12px;
        color: #fff;
        a {
          cursor: pointer;
        }
      }
      .loginBtn {
        width: 100%;
        background-color:  rgba(32, 147, 202, 1);
        border-radius: 6px;
        font-size: 22px;
        border: none;
        text-align: center;
        margin-top: 10px;
        color: #fff;
      }
      .ewmLoginContent:hover {
        .ewmLoginContentWeiyi {
          // transform: ;
          transform: translateX(-70px);
        }
        .ewmLoginContentImgtips {
          display: block;
        }
      }
      .ewmLoginContent {
        width: 335px;
        margin: auto;
        position: relative;
        height: 217px;
        .ewmLoginContentWeiyi {
          transform: translateX(7px);
          display: block;
          margin: 0 auto;
          padding-top: 30px;
          transition: all 0.6s;
          position: relative;
          z-index: 10;
          // transition: t;
        }
        .ewmLoginContentImgtips {
          position: absolute;
          right: 0;
          top: 0;
          float: right;
          display: none;
        }
      }
      .ewmLoginBttom {
        display: block;
        margin: 0 auto;
        margin-top: 30px;
      }
    }
  }
  .el-button {
    width: 100%;
  }
  ::v-deep .el-select .el-input__inner {
    cursor: auto;
  }
  .el-button {
    background: #2093ca;
    color: #ffffff;
    font-size: 20px;
    letter-spacing: 4px;
  }
  .tip-box {
    height: 80%;
    margin-left: 70px;
    line-height: 20px;
    .tip {
      color: rgba(128, 128, 128, 1);
      font-size: 14px;
    }
  }


  .search-bg ::v-deep .el-input__inner,
  .el-button {
    height: 54px !important;
    border: 1px solid #2093ca;
  }
  .msg-box {
    box-sizing: content-box;
    height: 460px;
    padding-top:50px;
    padding-bottom:50px;
  }
  .all-trade {
    .allNews {
      font-size: 18px;
      font-weight: 400;
      padding: 0 0 10px 20px;
      color: rgba(26, 26, 26, 1);
    }
    hr {
      color: rgba(204, 204, 204, 1);
    }
    .detail-item {
      cursor:pointer;
      height: 210px;
      background: #ffffff;
      padding: 30px;
      display: flex;
      //  justify-content: space-between;
      align-items: center;
      border-radius: 14px;
      margin-top: 20px;
      .detail-img{
        object-fit: cover;
        height: 160px;
        width: 160px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        overflow: hidden;
        border-radius: 10px;
        >img {
          width: 120%;
          height: 100%;
        }
      }
      .word-box {
        padding-left: 30px;
        text-align: left;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        h1 {
          font-size: 24px;
          font-weight: 700;
          cursor: default;
        }
        p {
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
          color: rgba(114, 113, 113, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
        .sub-box {
          display:flex;
          width:100%;
          justify-content: space-between;
          div {
            display:flex;
            align-items: center;
            font-size: 14px;
            font-weight: 400;
            color: rgba(166, 166, 166, 1);
            padding: 5px;
          }
        }
      }
    }
    .pagination {
      position: sticky;
      text-align: center;
      padding:50px 0 70px 0;
    }
  }
  ::v-deep .el-pagination .btn-next, ::v-deep .el-pagination .btn-prev,::v-deep .el-pager li.active{
    background: #2093ca;
    color: #ffffff;
    padding-left: 6px;
    padding-right: 6px;
  }
  .el-button {
    background: #2093ca;
  }

  ::v-deep .el-pager li {
    margin: 0 3px;
    border: 0.86px solid rgba(204, 204, 204, 1);
  }
  ::v-deep .el-pagination .btn-prev, ::v-deep .el-pagination .btn-next{
    border: 0.86px solid rgba(204, 204, 204, 1);
  }
}
</style>